module.exports = __webpack_public_path__ + "img/phpconf_2015_01.27d5b65a.jpg";